// Set a user input which trumps all over data with the same attribute name
export interface SetUserInputAction {
  type: "SET_USER_INPUT";
  path: string;
  value: any;
}

export function setUserInput(path: string, value: any): SetUserInputAction {
  return {
    type: "SET_USER_INPUT",
    path,
    value,
  };
}
